exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "textarea[data-v-8f154972] {\n  resize: vertical;\n}", ""]);

// exports
